<template>
  	<div class="stores">
		<div style="padding:10px 0">
			<el-breadcrumb separator-class="el-icon-arrow-right">
				<el-breadcrumb-item :to="{ path: '/collection' }">精选合集</el-breadcrumb-item>
				<el-breadcrumb-item> {{this.trainingPlansId?'修改':'创建'}}精彩合集</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
	    <div class="traingplan">
	    	<el-form :model="ruleForm" ref="ruleForm" :rules="rules" status-icon label-width="250px">
	        	<el-form-item label="精彩合集名称" prop="title">
	          		<el-input v-model="ruleForm.title" placeholder="请输入精彩合集名称" style="width:40%" ></el-input>
	        	</el-form-item>
	        	<el-form-item label="精彩合集介绍" prop="collectionIntroduction">
	          		<el-input type="textarea" v-model="ruleForm.collectionIntroduction" placeholder="请输入精彩合集介绍" style="width:40%" :rows="5"></el-input>
	        	</el-form-item>
	        	<el-form-item label="训练强度" prop="planIntensity">
		          	<el-select v-model="ruleForm.compilationIntensity" placeholder="请选择训练强度" style="width: 40%;">
		            	<el-option v-for="item in courseIntensityList" :key="item.id" :label="item.name" :value="item.id" >{{item.name}}</el-option>
		          </el-select>
		        </el-form-item>
		        <el-form-item label="卡路里" prop="calorie">
		          	<el-input v-model="ruleForm.calorie" placeholder="请输入卡路里" style="width:40%" ></el-input> kcal
		        </el-form-item>


		        <!-- 上传图片 -->
	        	<el-form-item label="APP封面图片(建议480*270格式JPG)" prop="appCoverUrl">
	          		<el-input v-model="ruleForm.appCoverUrl" placeholder style="width:40%"></el-input>
	          		<el-upload class="avatar-uploader" :action="tmpFiles" :show-file-list="false" :headers="headers" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
	            		<img v-if="ruleForm.appCoverUrl" :src="ruleForm.appCoverUrl" class="avatar" />
	            		<i v-else class="el-icon-plus avatar-uploader-icon"></i>
	          		</el-upload>
	        	</el-form-item>

	        	<el-form-item label="APP详情图片(建议480*270格式JPG)" prop="appDetailUrl">
	          		<el-input v-model="ruleForm.appDetailUrl" placeholder style="width:40%"></el-input>
	          		<el-upload class="avatar-uploader" :action="tmpFiles" :show-file-list="false" :headers="headers" :on-success="handleAvatarSuccess4" :before-upload="beforeAvatarUpload4">
	            		<img v-if="ruleForm.appDetailUrl" :src="ruleForm.appDetailUrl" class="avatar" />
	            		<i v-else class="el-icon-plus avatar-uploader-icon"></i>
	          		</el-upload>
	        	</el-form-item>

	        	<el-form-item label="屏端封面图片(建议484*272格式JPG)" prop="screenCoverUrl">
	          		<el-input v-model="ruleForm.screenCoverUrl" placeholder style="width:40%"></el-input>
	          		<el-upload class="avatar-uploader" :action="tmpFiles" :show-file-list="false" :headers="headers" :on-success="handleAvatarSuccess5" :before-upload="beforeAvatarUpload5">
	            		<img v-if="ruleForm.screenCoverUrl" :src="ruleForm.screenCoverUrl" class="avatar" />
	            		<i v-else class="el-icon-plus avatar-uploader-icon"></i>
	          		</el-upload>
	        	</el-form-item>

	        	<el-form-item label="屏端详情封面(建议1920*435格式JPG)" prop="screenDetailUrl">
	          		<el-input v-model="ruleForm.screenDetailUrl" placeholder style="width:40%"></el-input>
	          		<el-upload class="avatar-uploader" :action="tmpFiles" :show-file-list="false" :headers="headers" :on-success="handleAvatarSuccess3" :before-upload="beforeAvatarUpload3">
	            		<img v-if="ruleForm.screenDetailUrl" :src="ruleForm.screenDetailUrl" class="avatar" />
	            		<i v-else class="el-icon-plus avatar-uploader-icon"></i>
	          		</el-upload>
	        	</el-form-item>


	        	<el-form-item label="添加封面图">
	          		<el-button type="primary" style="margin-bottom:20px" @click="addCoverLine">添加</el-button>
	          		<el-table :data="ruleForm.fideaturedCompilationCovers" style="width: 100%" border class="paytab" v-if="ruleForm.fideaturedCompilationCovers.length>0">
				      	<el-table-column label="封面类型" width='160' >
				      		<template slot-scope="scope">
					      		<el-radio-group v-model="scope.row.coverType">
					      			<el-radio :label='2'>图片</el-radio>
							      	<el-radio :label='1'>视频</el-radio>
							    </el-radio-group>
							</template>
				      	</el-table-column>

				      	<el-table-column label="上传" width='200'>
				      		<template slot-scope="scope">
					      		<el-button type="primary" size='small' @click="handleClick(scope.$index,2)">上传图片</el-button>
					      		<el-button type="primary" size='small' @click="handleClick(scope.$index,1)" v-if="scope.row.coverType==1">上传视频</el-button>

					      		<div style="margin-top:10px">
					      			<img :src="scope.row.coverUrl" class="avatar" v-if="scope.row.coverUrl">
					      		</div>

					      		<div style="margin-top:10px">
					      			<video :src="scope.row.videoUrl" style="width:180px" v-if="scope.row.videoUrl && scope.row.coverType==1" controls="controls"></video>
					      		</div>
					      		
							</template>
				      	</el-table-column>

				      	
				      	<el-table-column  label="操作" width='110'>
				      		<template slot-scope="scope">
				                <i class="el-icon-sort-up operation" @click="sortimgUp(scope.$index,scope.row)"></i>
				                <i class="el-icon-sort-down operation" @click="sortimgDown(scope.$index,scope.row)"></i>
				                <i class="el-icon-remove-outline operation" @click="deleteimgRow(scope.$index,ruleForm.fideaturedCompilationCovers,scope.row)" style="margin-left:5px"></i>
				            </template>
				      	</el-table-column>
				    </el-table>
	        	</el-form-item>

	        	<el-form-item label="选择课程" >
	          		<el-button type="primary" style="margin-bottom:20px" @click="chooseCourse(-1)">添加</el-button>
	          		<el-table :data="ruleForm.fideaturedCompilationCourseVos" style="width: 100%" border class="paytab" v-if="ruleForm.fideaturedCompilationCourseVos.length>0">
				      	<el-table-column prop="coureName" label="课程名称" width='110'>
				      		<template slot-scope="scope">
				      			{{scope.row.coureName}}
				      		</template>
				      	</el-table-column>
				      	<el-table-column prop="coachName" label="教练名" width='110'>
				      		<template slot-scope="scope">
				      			{{scope.row.coachName}}
				      		</template>
				      	</el-table-column>

				      	<el-table-column prop="courseStatus" label="是否显示？" width='110'>
				      		<template slot-scope="scope">
				      			<el-checkbox v-model="scope.row.courseStatus" ></el-checkbox>
				      		</template>
				      	</el-table-column>
				      	<el-table-column prop="originalVideo" label="链接地址">
				      		<template slot-scope="scope">
				      			<div style="display:flex;align-items:center;">
				      				{{scope.row.originalVideo}}
				      				<input type="hidden" v-model="scope.row.courseId">
				      				<input type="hidden" v-model="scope.row.coachId">
				      				<input type="hidden" v-model="scope.row.trainingPlansId">
				      			</div>
				      		</template>
				      	</el-table-column>
				      	<el-table-column  label="操作" width='180'>
				      		<template slot-scope="scope">
								<el-button
                                    @click="chooseCourse(scope.$index)"
                                    type="text"
                                    size="small"
                                    icon="el-icon-s-order">编辑</el-button>
                            <el-popconfirm title="确定删除吗？" @confirm="deleteRow(scope.$index,scope.row.id)"> 
                                <el-button
                                    slot="reference"
                                    type="text"
                                    size="small"
                                    style="color:red;"
                                    icon="el-icon-delete">删除</el-button>
                            </el-popconfirm>
				      		</template>
				      	</el-table-column>
				    </el-table>

	        	</el-form-item>
	        	<el-form-item>
	        		<el-button type="primary" style="width:100px" @click="create('ruleForm')" >{{this.trainingPlansId?'确认修改':'创建'}}</el-button>
	        	</el-form-item>
	      	</el-form>

	    </div>
	    <!-- 选择课程弹框 -->
	    <el-dialog title="选择课程" :visible.sync="dialogVisible" width="80%" top="3%" :before-close="courseClose">
	    	<div class="hall-search-list">
				<span class="hall-search-name">课程名称</span>
				<input type="text" style="width:20%;" class="el-input__inner" v-model="courseName" @keyup.enter="search_mine()" placeholder="请输入课程名称" />
				<span class="hall-search-name">教练名称</span>
				<input type="text" style="width:20%;" class="el-input__inner" v-model="coachName" @keyup.enter="search_mine()" placeholder="请输入教练名称" />
				<span class="hall-search-name">课程时间</span>
				<el-date-picker
		      		v-model="timeVal"
		      		type="daterange"
		      		range-separator=" 至 "
		      		start-placeholder="课程开始日期"
		      		end-placeholder="课程结束日期"
	      			value-format="yyyy-MM-dd">
	    		</el-date-picker>
			    <el-button type="primary" style="margin-left:10px" @click="search_mine()">搜索</el-button>
		    </div>
			<div style="padding:10px 0">
				<el-tabs v-model="activeName" @tab-click="topnav">
					<el-tab-pane label="全部" name="-1"></el-tab-pane>
					<el-tab-pane v-for="(item,index) in selData" :key="index" :label="item.name" :name="index+''"></el-tab-pane>
				</el-tabs>
			</div>
	      	<el-scrollbar style="height:650px; width:100%;cursor:pointer;">
	        	<template>
	          		<el-table ref="multipleTable" :row-key="getRowKeys" :data="courseData" highlight-current-row tooltip-effect="dark" style="width: 100%" @current-change="handleCurrentChange" @selection-change="handleSelectionChange1">
						<el-table-column type="selection"  width="55" align="center" :reserve-selection="true" :selectable='isDisabled' v-if="planDetailsIndex == -1"></el-table-column>
						<el-table-column align="center" v-if="planDetailsIndex >=0">
							<template slot-scope="scope">
								<span style="font-size:12px;" v-if="isDisabled(scope.row)">可选课程</span>
								<span style="font-size:12px;color:red;" v-else>已选课程</span>
							</template>
						</el-table-column>
		            	<el-table-column label="课程教练" align="center">
							<template slot-scope="scope">{{scope.row.coachName}}</template>
						</el-table-column>
						<el-table-column label="课程名称" align="center">
							<template slot-scope="scope">{{scope.row.name}}</template>
						</el-table-column>
						<el-table-column label="课程类型" align="center">
							<template slot-scope="scope">{{scope.row.courseKindName}}</template>
						</el-table-column>
						<el-table-column label="消耗" align="center">
							<template slot-scope="scope">{{scope.row.calories}}</template>
						</el-table-column>
						<el-table-column label="训练压力" align="center">
							<template slot-scope="scope">{{scope.row.tss}}</template>
						</el-table-column>
						<el-table-column label="强度因子" align="center">
							<template slot-scope="scope">{{scope.row.vi}}</template>
						</el-table-column>
						<el-table-column label="课程时长" align="center">
							<template slot-scope="scope">{{scope.row.duration}}</template>
						</el-table-column>
						<el-table-column label="操作" width="210" align="center">
						<template slot-scope="scope">
							<el-button
										@click="seeVideo(scope.row)"
									type="text"
									size="small"
									icon="el-icon-s-claim">视频预览</el-button>
						</template>
					</el-table-column>
	          		</el-table>
	        	</template>
		        <div class="block" style="padding:30px 10px;display: flex;justify-content: flex-end;position:relative;">
					<el-button type="primary" class="shure-button" @click="addCourseData()" v-if="planDetailsIndex == -1">确定</el-button>
		          	<el-pagination @current-change="handleCurrentChangePage" :current-page="pageNum" :page-size="limit" layout="total, prev, pager, next, jumper" :total="totalPage"></el-pagination>
		        </div>
	      	</el-scrollbar>
	    </el-dialog>

	    <el-dialog :title="coveimgOrvideo==1?'上传视频':'上传图片'" width="15%" :visible.sync="dialogVisible2" :before-close="handleClose" :close-on-click-modal="false">
      		<el-upload class="avatar-uploader" :key="timer" :action="tmpFiles" :show-file-list="false" :on-success="coverSuccess" :on-progress="uploadProcess" :headers="headers" style="margin-top:-25px">
        		<i class="el-icon-plus avatar-uploader-icon" />
        		<el-progress v-if="videoFlag == true" type="circle" :percentage="uploadPercent" ></el-progress>
      		</el-upload>
	    </el-dialog>

		<el-dialog title="课程视频" :visible.sync="dialog1" width="50%" top="10%" :before-close="originaClose">
		<video :src="originalVideoHigh" autoplay controls style="width:100%;height:500px;" ref="originaVideo"></video>
	</el-dialog>
  	</div>
</template>

<script>
import Vue from 'vue'
export default {
  	components: {},
	mounted() {
		this.trainingPlansId=this.$route.query.id
	    if(this.trainingPlansId){
	    	this.init();
	    }
		this.sportsKind();
	},
  	data() {
    	return {
	      	headers: {
	        	"yj-admin-token": localStorage.getItem("token") 
	      	},
	      	timer:false,
	      	dialog1:false,
			originalVideoHigh:'',
	      	timer2:false,
	      	videoFlag: false, //刚开始的时候显示为flase
	      	uploadPercent:'0%',
	      	coveimgOrvideo:1,
      		ruleForm: {
      			appCoverUrl:'',
      			appDetailUrl:'',
      			screenCoverUrl:'',
      			screenDetailUrl:'',
      			fideaturedCompilationCourseVos:[],
      			fideaturedCompilationCovers:[]
      		},
      		rules:{
      				
      		},
		    tmpFiles: process.env.API_ROOT + "/tmpFiles",
		    dialogVisible:false,
		    dialogVisible2:false,
		    pageNum: 1,
      		limit: 10,
      		totalPage: 10,
			activeName:'-1',
      		courseData: [], //课程列表
      		courseName:'',
      		coachName:'',
			sportsKindId:'',
      		trainingPlansId:'',
      		planDetailsIndex:'',
      		timeVal:'',
      		courseIntensityList:[
      			{id:1,name:'初级'},
      			{id:2,name:'中级'},
      			{id:3,name:'高级'},
      		],
      		coverSuccessIndex:'',
			multipleSelectionCurrent:[],
			selData:[],
			multipleSelection:[]
    	};
  	},
  	methods: {
		seeVideo(e){
			console.log('e',e);
			this.originalVideoHigh=e.originalVideoHigh;
			this.dialog1=true;
		},
		originaClose(done){
			this.$refs['originaVideo'].pause();
			done();
		},
		topnav() {
            let index=Number(this.activeName);
            this.sportsKindId=index === -1?0:(Array.isArray(this.selData) && this.selData.length>0?this.selData[index].id:0)
            this.pageNum = 1;
            this.selcourseData();
        },
		//选择运动种类
        sportsKind() {
            this.$get('/course/sportsKind', {})
			.then(res => {
				console.log(res);
				if (res.code == 0) {
					this.selData = Array.isArray(res.data)?res.data:[];
				} else {
					this.$message.error(JSON.stringify(res.message));
				}
			})
			.catch(() => {
				console.log();
			});
        },
	    //初始化表格数据
	    init() {
	    	var params = {
        		compilationId:this.trainingPlansId
      		};
	      	this.$get("/fideatured/getFideaturedCompilation", params)
	        .then(res => {
	        	console.log(res)
	          	if (res.code == 0) {
		            this.ruleForm = res.data;
	          	} else {
		            this.$message({
		              	message: res.message,
		              	type: "warning"
		            });
		            return false;
		        }
	        })
	    },
	    handleAvatarSuccess(res, file) {
	      	console.log(res);
	      	this.ruleForm.appCoverUrl = res.data.url;
	    },
	    beforeAvatarUpload(file) {
	      	const isJPG = file.type === "image/jpeg";
	      	//const isLt2M = file.size / 1024 / 1024 < 2;
	      	if (!isJPG) {
	      	  this.$message.error('上传头像图片只能是 JPG 格式!');
	      	}
	      	// // if (!isLt2M) {
	      	// //   this.$message.error('上传头像图片大小不能超过 2MB!');
	      	// // }
	      	return isJPG;	
	    },
	    handleAvatarSuccess3(res, file) {
	      	console.log(res);
	      	this.ruleForm.screenDetailUrl = res.data.url;
	    },
	    handleAvatarSuccess4(res, file) {
	      	this.ruleForm.appDetailUrl = res.data.url;
	    },
	    handleAvatarSuccess5(res, file){
	    	this.ruleForm.screenCoverUrl = res.data.url;
	    },
	    beforeAvatarUpload3(file) {
	      	const isJPG = file.type === "image/jpeg";
	      	if (!isJPG) {
	      	  this.$message.error('上传头像图片只能是 JPG 格式!');
	      	}
	      	return isJPG;	
	    },
	    beforeAvatarUpload4(file) {
	      	const isJPG = file.type === "image/jpeg";
	      	if (!isJPG) {
	      	  this.$message.error('上传头像图片只能是 JPG 格式!');
	      	}
	      	return isJPG;	
	    },
	    beforeAvatarUpload5(file) {
	      	const isJPG = file.type === "image/jpeg";
	      	if (!isJPG) {
	      	  this.$message.error('上传头像图片只能是 JPG 格式!');
	      	}
	      	return isJPG;	
	    },
	    handleClick(index,val){
	    	this.dialogVisible2=true;
	    	this.coverSuccessIndex=index;
	    	this.coveimgOrvideo=val
	    },
	    coverSuccess(res,file){//上传封面图
	    	if(res.data.url){
	    		this.uploadPercent=0;
	    		this.videoFlag=false;
	    		if(this.coveimgOrvideo==1){
	    			this.ruleForm.fideaturedCompilationCovers[this.coverSuccessIndex].videoUrl = res.data.url;
	    			this.$set(this.ruleForm.fideaturedCompilationCovers,this.ruleForm.fideaturedCompilationCovers[this.coverSuccessIndex].videoUrl,this.ruleForm.fideaturedCompilationCovers[this.coverSuccessIndex].videoUrl)
	    		}else{
	    			this.ruleForm.fideaturedCompilationCovers[this.coverSuccessIndex].coverUrl = res.data.url;
	    			this.$set(this.ruleForm.fideaturedCompilationCovers,this.ruleForm.fideaturedCompilationCovers[this.coverSuccessIndex].coverUrl,this.ruleForm.fideaturedCompilationCovers[this.coverSuccessIndex].coverUrl)	
	    		}
	    		this.dialogVisible2=false;
	    	}
	    },
		isDisabled(row,index){
			let falg=true;
			for(let i=0;i<this.ruleForm.fideaturedCompilationCourseVos.length;i++){
				if(row.id == this.ruleForm.fideaturedCompilationCourseVos[i].courseId){
					falg=false;
					break;
				}
			}
			return falg
		},
	    addCoverLine(){
	    	if(this.trainingPlansId){
	    		var newValue = {
		    		planId:this.trainingPlansId,
		    		coverType:2
		    	};
	    	}else{
	    		var newValue = {
		    		coverType:2,
		    		planId:''
		    	};
	    	}
	      	this.ruleForm.fideaturedCompilationCovers.push(newValue);
	    },
	    uploadProcess(event, file, fileList) {
	      	this.videoFlag = true;
	      	this.uploadPercent = parseInt(file.percentage);
	    },
	    deleteRow(index,id){
	    	if(id){
	    		this.$delete('/fideatured/delFideaturedCompilationDetail',{detailId:id})
	        	.then(res => {
	          		if(res.code==0){
	          			this.$message.success('删除成功');
						this.ruleForm.fideaturedCompilationCourseVos.splice(index, 1);
	          		}else {
	            		this.$message.error(res.message);
	          		}
	        	})
	    	}else{
				this.ruleForm.fideaturedCompilationCourseVos.splice(index, 1);
			}
	    },
	    deleteimgRow(index,rows,row){
	    	var that=this;
	    	rows.splice(index, 1);
	    	if(row.id){
	    		that.$axios.delete("/fideatured/delFideaturedCompilationCover?coverId=" + row.id)
	        	.then(res => {
	        		console.log(res)
	          		if(res.data.code==0){
	          			that.$message({
		                    message: "删除成功",
		                    type: "success"
	                  	});
	          		}else {
	            		that.$message({
	              			message: res.message,
	              			type: "warning"
	            		});
	            		return false;
	          		}
	        	})
	    	}
	    },
	    chooseCourse(index){
	    	this.dialogVisible=true;
	    	this.planDetailsIndex=index;
	    	this.selcourseData();
	    },
	    //点击选择用户行
	    handleCurrentChange(val) {
			if(this.planDetailsIndex>=0){
				let cIndex=this.$_.findIndex(this.ruleForm.fideaturedCompilationCourseVos, function(o) { return o.courseId == val.id });
				if (val && cIndex<0) {
					this.ruleForm.fideaturedCompilationCourseVos[this.planDetailsIndex].coureName = val.name;
					this.ruleForm.fideaturedCompilationCourseVos[this.planDetailsIndex].originalVideo = val.originalVideoHigh;
					this.ruleForm.fideaturedCompilationCourseVos[this.planDetailsIndex].courseId=val.id;
					this.ruleForm.fideaturedCompilationCourseVos[this.planDetailsIndex].coachId=val.coachId;
					this.ruleForm.fideaturedCompilationCourseVos[this.planDetailsIndex].coachName=val.coachName;
					if(this.trainingPlansId){
						this.ruleForm.fideaturedCompilationCourseVos[this.planDetailsIndex].trainingPlansId=this.trainingPlansId;
					}
					this.dialogVisible = false
				}
			}
	    },
		getRowKeys(row) {
			return row.id;
		},
		handleSelectionChange1(val){
			console.log(val);
			this.multipleSelection=val;
		},
		addCourseData(){
			let select=this.$_.uniqBy(this.multipleSelection,'id');
			this.$refs.multipleTable.clearSelection();
			select.forEach(val=>{
				let newValue = {
		    		coureName:val.name,
		    		originalVideo:val.originalVideoHigh,
		    		courseId:val.id,
		    		coachId:val.coachId,
		    		coachName:val.coachName,
		    		courseStatus:true
		    	};
				if(this.trainingPlansId)newValue.trainingPlansId=this.trainingPlansId;
				this.ruleForm.fideaturedCompilationCourseVos.push(newValue);
			})
			this.dialogVisible = false;
		},
	    //当前教练页数
	    handleCurrentChangePage(val) {
	      	this.pageNum = val;
	      	this.selcourseData();
	    },
	    selcourseData(){
	    	var params = {
	        	pageNum: this.pageNum,
	        	limit: this.limit,
	        	courseName:this.courseName,
	        	coachName:this.coachName,
				sportsKindId:this.sportsKindId,
	        	courseStartTime:this.timeVal.length>0?this.$moment(this.timeVal[0]).valueOf():'',
	        	courseEndTime:this.timeVal.length>0?this.$moment(this.timeVal[1]).valueOf():''
	      	};
	      	this.$get("/course/getTrainingPlanCourseList", params)
	        .then(res => {
	        	console.log(res)
	          	if (res.code == 0) {
	            	this.courseData = Array.isArray(res.data.list)?res.data.list:[];
	            	this.totalPage = res.data.total;
	          	} else {
		            this.$message({
		              	message: res.message,
		              	type: "warning"
		            });
		            return false;
	          	}
	        })
	    },
	    search_mine(){
	    	this.selcourseData();
	    },
	    //弹框关闭按钮
	    handleClose(done) {
	      	done()
	    },
		courseClose(done){
			this.$refs.multipleTable.clearSelection();
			this.multipleSelection=[];
			done();
		},
	    change(e){
  			this.$forceUpdate()
  		},
  		
	    create(formName){
	    	var that=this;
	    	that.$refs[formName].validate((valid) => {
	          	if (valid) {
	          		if(!that.ruleForm.title){
	          			that.$message({
			              	message: '精彩合集名称不能为空',
			              	type: "warning"
			            });
			            return false;
	          		}
	          		if(!that.ruleForm.appCoverUrl){
	          			that.$message({
			              	message: '请上传封面图',
			              	type: "warning"
			            });
			            return false;
	          		}
	          		if(!that.ruleForm.screenCoverUrl){
	          			that.$message({
			              	message: '请上传背景图',
			              	type: "warning"
			            });
			            return false;
	          		}
	          		if(that.ruleForm.fideaturedCompilationCourseVos.length<1){
	          			that.$message({
			              	message: '课程至少添加一条',
			              	type: "warning"
			            });
			            return false;
	          		}
	          		that.ruleForm.fideaturedCompilationCovers.map(function(val,index) {
	          			val.sort=index;
	          		})
	          		that.ruleForm.fideaturedCompilationCourseVos.map(function(val) {
	          			if(val.courseStatus==true){
	          				val.status=1
	          			}else{
	          				val.status=0;
	          			}
	          		})
	          		console.log(that.ruleForm)
	            	that.$post("/fideatured/addFideaturedCompilation",JSON.stringify(that.ruleForm))
			        .then(res => {
			          	if (res.code == 0) {
				            that.$message({
				              	message: that.trainingPlansId?"修改成功":"创建成功",
				              	type: "success",
				              	duration:1500,
					          	onClose:function(){
					          		that.$router.push({ path: "/collection" });
					          	}
				            });
			          	} else {
				            that.$message({
				              	message: res.message,
				              	type: "warning"
				            });
				            return false;
			          }
			        })
	          	} else {
	            	console.log('error submit!!');
	            	return false;
	          	}
	        });
	    },
	    sortimgUp(index,row){//添加封面图
	    	//console.log(index)
	    	if (index === 0) {
		        this.$message({
		          	message: '已经是第一个！',
		          	type: 'warning'
		        })
      		} else {
	        	let temp = this.ruleForm.fideaturedCompilationCovers[index - 1];
    			Vue.set(this.ruleForm.fideaturedCompilationCovers, index - 1, this.ruleForm.fideaturedCompilationCovers[index]);
    			Vue.set(this.ruleForm.fideaturedCompilationCovers, index, temp)
	      	}
	    },
	    sortimgDown(index,row){
	    	//console.log(index)
	    	if (index === (this.ruleForm.fideaturedCompilationCovers.length - 1)) {
	        	this.$message({
	          		message: '已经最后一个！',
	          		type: 'warning'
	        	})
		    } else {
	        	let i = this.ruleForm.fideaturedCompilationCovers[index + 1]
	        	Vue.set(this.ruleForm.fideaturedCompilationCovers, index + 1, this.ruleForm.fideaturedCompilationCovers[index])
	        	Vue.set(this.ruleForm.fideaturedCompilationCovers, index, i)
		    }
	    }
  	}
};
</script>

<style scoped>
::deep
.avatar-uploader-icon {
    width: 108px;
    line-height: 108px
}
::deep
.el-progress-circle{
	width: 108px;
    line-height: 108px;
    height: 108px;
}
.traingplan{
	font-size: 13px;
}
.operation{
	cursor: pointer;
	font-size: 22px
}
.topinput{
	margin-right: 10px;
}
.el-date-editor .el-range-separator{
	padding: 0
}
.shure-button{
	position: absolute;
	top:50%;
	left:10px;
	transform: translateY(-50%);
}
</style>




// WEBPACK FOOTER //
// src/views/coursesList/collection/addcollection.vue